import {IRequestOptions, TJson, TRequestParameters} from 'core/types';

export abstract class AbstractApiRequestInterceptor {
    public abstract intercept(
        request: TRequestParameters<RequestInit>,
        requestOption: IRequestOptions<TJson>,
    ): TRequestParameters<RequestInit>;
}
